import { instance, errorService } from '@/services/api'
import { masterAPIs } from '@/services/authConstantsV1'
import { gridProperties } from '@/services/column.config'
import { calculateGridHeight, customComparator } from '@/services/calculate'
import _ from 'lodash'
import { AgGridVue } from 'ag-grid-vue'
import Pagination from '@/components/DynamicComponents/Pagination'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    Pagination,
  },
  props: {
    tabKey: String,
    role: String,
  },
  data: function() {
    return {
      headStyle: {
        'font-weight': 'bold',
        background: 'transparent !important',
        color: '#000000d9 !important',
        padding: '0 10px',
      },
      count: 0,
      loading: false,
      spinner: false,
      defaultSortedBy: 'id',
      defaultSortOrder: true,
      page: 0,
      pageSize: 0,
      loadRefresh: false,
      gridOptions: null,
      columnDefs: [],
      frameworkComponents: null,
      tableParams: null,
      width: '100%',
      height: '400px',
      filters: {},
      tableState: null,
      scheduleList: [],
    }
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.pageSize = settings.application.defaultRecord
    this.loadConfig()
  },
  mounted() {
    window.addEventListener('resize', this.getWindowSize)
  },
  watch: {
    tabKey() {
      if (this.tabKey === '17') {
        this.filters = {}
        const data = this.gridOptions.api.getFilterModel()
        Object.keys(data).forEach(element => {
          const filterComponent = this.gridOptions.api.getFilterInstance(
            element,
          )
          filterComponent.setModel(null)
        })
        this.factorList = []
        this.loading = false
        this.getDepreciationSchedule(this.gridOptions)
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowSize)
  },
  methods: {
    loadConfig() {
      this.gridOptions = {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: true,
        tooltipShowDelay: 0,
        rowSelection: 'multiple',
        defaultColDef: {
          sortable: true,
          suppressMovable: true,
          comparator: customComparator,
          resizable: true,
          menuTabs: ['filterMenuTab'],
          filterParams: {
            buttons: ['apply'],
            newRowsAction: 'keep',
          },
        },
      }
      this.frameworkComponents = gridProperties.master.frameworks
      this.columnDefs = gridProperties.master.columns.depreciation
    },

    // Refresh Depreciation Schedule
    onRefresh() {
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach(element => {
        const filterComponent = this.gridOptions.api.getFilterInstance(element)
        filterComponent.setModel(null)
      })
      this.loading = true
      this.loadRefresh = true
      this.factorList = []
      this.page = 0
      this.defaultSortedBy = 'id'
      this.defaultSortOrder = true
      this.gridOptions.columnApi.applyColumnState({
        state: [
          {
            colId: 'id',
            sort: 'asc',
          },
        ],
        defaultState: { sort: null },
      })
      this.gridOptions.api.destroyFilter()
      this.filters = {}
      this.getDepreciationSchedule(this.gridOptions)
    },

    // Load Depreciation Schedule
    getDepreciationSchedule(params) {
      this.height = calculateGridHeight(
        'scheduleTable',
        this.count > this.pageSize,
      )
      this.loading = true
      this.loadRefresh = true
      instance
        .post(masterAPIs.depreciation.list, {
          pageSize: this.pageSize,
          currentPage: this.page,
          sortColumn: this.defaultSortedBy,
          isAscending: this.defaultSortOrder,
          id: _.get(this.filters, 'id', undefined),
          key: _.get(this.filters, 'key', undefined),
          depreciationType: _.get(this.filters, 'depreciationType', undefined),
          title: _.get(this.filters, 'title', undefined),
          tableHeading: _.get(this.filters, 'tableHeading', undefined),
          life: _.get(this.filters, 'life', undefined),
          special: _.get(this.filters, 'special', undefined),
          monthPis: _.get(this.filters, 'monthPis', undefined),
          label: _.get(this.filters, 'label', undefined),
          year: _.get(this.filters, 'year', undefined),
          value: _.get(this.filters, 'value', undefined),
          method: _.get(this.filters, 'method', undefined),
          convention: _.get(this.filters, 'convention', undefined),
          table: _.get(this.filters, 'table', undefined),
          notes: _.get(this.filters, 'notes', undefined),
        })
        .then(response => {
          this.tableParams = null
          this.tableParams = params
          this.scheduleList = _.get(response.data, 'result', [])
          this.count = _.get(response.data, 'totalCount', 0)
          this.height = calculateGridHeight(
            'scheduleTable',
            this.count > this.pageSize,
          )
          this.loading = false
          this.loadRefresh = false
          params.api.sizeColumnsToFit()
        })
        .catch(error => {
          this.loading = false
          this.loadRefresh = false
          errorService(error)
        })
    },

    // Ag Grid sort method
    sortChanged(value) {
      const colState = this.gridOptions.columnApi.getColumnState()
      const sortData = colState
        .filter(function(s) {
          return s.sort != null
        })
        .map(function(s) {
          return {
            colId: s.colId,
            sort: s.sort,
            sortIndex: s.sortIndex,
          }
        })
      this.loading = false
      this.scheduleList = []
      if (sortData.length > 0) {
        this.defaultSortedBy = sortData[0]['colId']
        this.defaultSortOrder = sortData[0]['sort'] === 'asc'
      } else {
        this.defaultSortedBy = 'key'
        this.defaultSortOrder = true
      }
      this.getDepreciationSchedule(this.gridOptions, 'sort')
    },

    getWindowSize() {
      this.height = calculateGridHeight(
        'scheduleTable',
        this.count > this.pageSize,
      )
    },

    onPagination(page) {
      this.loading = true
      this.page = page
      this.scheduleList = []
      this.selectedRowKeys = []
      this.getDepreciationSchedule(this.tableParams)
    },

    filterChanged() {
      this.filters = {}
      const data = this.gridOptions.api.getFilterModel()
      Object.keys(data).forEach((element, index) => {
        this.filters[element] = Object.values(data)[index]['filter']
      })
      this.loading = true
      this.page = 0
      this.scheduleList = []
      this.getDepreciationSchedule(this.gridOptions)
    },
  },
}
